<template>
  <div>
    <!-- Long -->
    <p v-if="displayType === 'long'">
      This Fixed Income Maturity analysis is based on the number of days to maturity of directly held fixed income securities as well as securities held through funds.
      Duration for securities held through funds is based on the difference between the maturity date and the reporting period end date of the fund's latest NPORT SEC filing.
      <template v-if="portfolio && benchmark">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }} and {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
      <template v-else-if="portfolio">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }}.
      </template>
      <template v-else-if="benchmark">
        This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
    </p>

    <!-- Short -->
    <p v-else>
      This Fixed Income Maturity analysis is based on the number of days to maturity of directly held fixed income securities as well as securities held through funds.
      Duration for securities held through funds is based on the difference between the maturity date and the reporting period end date of the fund's latest NPORT SEC filing.
      <template v-if="portfolio && benchmark">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }} and {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
      <template v-else-if="portfolio">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }}.
      </template>
      <template v-else-if="benchmark">
        This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
    </p>
  </div>
</template>


<script>
export default {
  name: 'FixedIncomeDurationMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    portfolioName() {
      return this.portfolio?.name || 'Portfolio';
    },
    benchmarkName() {
      return this.benchmark?.name || 'Benchmark';
    },
    breakdown() {
      return {
        portfolio: this.portfolio?.sector_market_cap_asset_class_breakdown,
        benchmark: this.benchmark?.sector_market_cap_asset_class_breakdown,
      };
    },
    coverage() {
      return {
        portfolio: this.breakdown.portfolio?.duration_breakdown_coverage || 0,
        benchmark: this.breakdown.benchmark?.duration_breakdown_coverage || 0,
      };
    },
    percentCoverage() {
      return {
        portfolio: this.formatNumber(this.coverage.portfolio),
        benchmark: this.formatNumber(this.coverage.benchmark),
      };
    },
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString('en-US', { style: 'percent' });
    },
  },
};
</script>
